module.exports = __webpack_public_path__ + "static/media/bg5.0b37f7db.jpg";